import { ReactFlowProvider } from '@xyflow/react';
import { Automations } from 'components/rules/automations/Automations';
import { MainLayout } from 'layouts/MainLayout';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getAllAudiences } from 'store/audiences/audiencesActions';
import { getAllPerks } from 'store/perks/perksActions';

export const AutomationsPage = () => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        getAllPerks()(dispatch);
        getAllAudiences()(dispatch);
    }, [dispatch]);
    return (
        <ReactFlowProvider>
            <MainLayout pageName="Automations" pageDescription="Explore the existing automations" noScroll>
                <Automations />
            </MainLayout>
        </ReactFlowProvider>
    );
};
